import React from 'react';
import { NavTriggersProps } from './types/NavTriggers.types';
import './NavTriggers.scss';

const NavTriggers = ({
  onNavToolsToggle,
  onNavMainToggle,
}: NavTriggersProps) => {
  return (
    <div className="NavTriggers">
      <span
        className="icon icon-lens NavTriggers__Toggle"
        onClick={onNavToolsToggle}
      />
      <div className="NavTriggers__hamburger" onClick={onNavMainToggle}>
        <span className="NavTriggers__l1" />
        <span className="NavTriggers__l2" />
        <span className="NavTriggers__l3" />
      </div>
    </div>
  );
};

export default NavTriggers;
